// extracted by mini-css-extract-plugin
export default {"mainStyles":"DynamicTextarea_mainStyles__3rV9C"};